module.exports = __webpack_public_path__ + "img/checkout-pants.df42745f.svg";